import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "lang-list" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "lang-desc" }

import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { router } from '@/router';


export default {
  __name: 'LangSelect',
  setup(__props) {

const { locale } = useI18n()

const selfRef = ref(null);
const langList = ref([
  { type: 'en-US', desc: 'English', icon: 'english.webp' },
  { type: 'tl-PH', desc: 'Filipino', icon: 'filipino.webp' },
]);
const showLangSelect = ref(false);

const currentLang = computed(() => langList.value.filter(item => item.type === locale.value)[0])

const doSwitchLang = (item) => {
  locale.value = item.type;
  showLangSelect.value = false;
  localStorage.setItem('i18n',  item.type);
  router.go(0)
}

return (_ctx, _cache) => {
  const _component_van_image = _resolveComponent("van-image")
  const _component_van_popover = _resolveComponent("van-popover")
  const _directive_audio = _resolveDirective("audio")

  return (_openBlock(), _createElementBlock("div", {
    class: "lang-select-comp",
    ref_key: "selfRef",
    ref: selfRef
  }, [
    _createVNode(_component_van_popover, {
      show: showLangSelect.value,
      "onUpdate:show": _cache[0] || (_cache[0] = $event => ((showLangSelect).value = $event)),
      placement: "bottom-end",
      teleport: selfRef.value
    }, {
      reference: _withCtx(() => [
        (currentLang.value)
          ? (_openBlock(), _createBlock(_component_van_image, {
              key: 0,
              class: "lang-icon",
              src: require(`@/assets/img/common/lang/${currentLang.value.icon}`)
            }, null, 8, ["src"]))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(langList.value, (item) => {
            return _withDirectives((_openBlock(), _createElementBlock("div", {
              class: "lang-item flex",
              key: item.type,
              onClick: $event => (doSwitchLang(item))
            }, [
              _createVNode(_component_van_image, {
                class: "lang-icon",
                src: require(`@/assets/img/common/lang/${item.icon}`)
              }, null, 8, ["src"]),
              _createElementVNode("div", _hoisted_3, _toDisplayString(item.desc), 1)
            ], 8, _hoisted_2)), [
              [_directive_audio]
            ])
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["show", "teleport"])
  ], 512))
}
}

}